import Cookie from './http/cookie';
import Data from './http/data';

export default class Http
{
	static Cookie: Cookie = Cookie;
	static Data: Data = Data;
}